import styled from 'styled-components'

import { COLORS } from '@probatix/common/constants/colors'

interface IStyledBiomarkerCard {
  noLine?: boolean
}

export const StyledBiomarkerCard = styled.div<IStyledBiomarkerCard>`
  padding: 22px 0;
  border-bottom: ${(props) => ((props.noLine) ? 0 : `1px solid ${COLORS.CADET_BLUE}`)};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: calc(calc(100vh - calc((100vh - 100%))) - 200px);

`
export const StyledBiomarkerName = styled.div`
  background: ${COLORS.PURPLE2};
  border-radius: 8px;
  padding: 2px 8px;
  font-family: 'Figtree';
  font-style: normal;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 24px;
  text-align: center;
  color: ${COLORS.GRAY_3};
  margin-bottom: 8px;
`
export const StyledBiomarkerDescription = styled.div`
  font-family: 'Figtree';
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;

  h1 {
    font-size: 1rem;
    font-weight: 700;
  }

  p {
    font-size: 0.775rem;
    font-weight: 400;
  }
`
export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
`
